import { render, staticRenderFns } from "./stories.vue?vue&type=template&id=82139c14&scoped=true"
import script from "./stories.vue?vue&type=script&lang=js"
export * from "./stories.vue?vue&type=script&lang=js"
import style0 from "./stories.vue?vue&type=style&index=0&id=82139c14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82139c14",
  null
  
)

export default component.exports